import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/unbounded/wght.css';
import '@fontsource-variable/source-sans-3/wght.css';
import '@/styles/app.css';
import { App } from '@/components/App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
